import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { nextAction, checkPreviousAction } from 'actions/workflow';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Grid, Column } from 'components/Layout';

const CreditAppDoc = () => {
  const workflow = useSelector((state) => state.workflow);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const applicationId = get(workflow, 'attributes.entityId');
  const [height, setHeight] = useState(0);
  const key = searchParams.get('key');

  const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const updateWindowDimensions = () => {
    setHeight(window.innerHeight);
  };

  const onMessageReceived = (event) => {
    const { data } = event;
    const dataJson = isJson(data) ? JSON.parse(data) : data;

    if (data.event === 'session_timeout') {
      navigate(`/fsl/docusign/timeout?key=${key}`);
    } else if (dataJson.event === 'session_view.document.completed') {
      if (key) {
        dispatch(nextAction({
          data: {
            event: dataJson.event,
            eid: dataJson.data.uuid,
            id: dataJson.applicationId,
            error: null,
          },
          url: `/workflows/fsl/${key}/next`,
          success: (response) => {
            navigate(`${response.data.url.split('?')[0]}?key=${key}`, {
              state: {
                data: response.data.data,
              },
            });
          },
          fail: (error) => {
            console.log(error);
          },
        }));
      }
    }
  };

  useEffect(() => {
    if (!key) {
      navigate(`/fsl/autopayelection?key=${key}`, { replace: true });
    } else if (get(workflow, ['data', 'data']) === undefined) {
      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/${key}/checkin`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: () => {
          navigate(`/fsl/autopayelection?key=${key}`, { replace: true });
        },
      }));
    }

    window.addEventListener('message', onMessageReceived, false);
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('message', onMessageReceived, false);
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  return (
    <Fragment>
      <Header />
      <section className="grid-container fluid">
        <div className="grid-container fluid page-sign-loan">
          <Grid>
            {applicationId ? (
              <div className="small-12 large-12" style={{ textAlign: 'left', padding: '1rem 1rem 0' }}>
                <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
              </div>
            ) : null}
            <Column className="small-12 large-12">
              <iframe
                src={get(workflow, ['data', 'data', 'url'])}
                width="100%"
                title="docusign"
                id="docusign"
                frameBorder="0"
                height={height - 90}
              />
            </Column>
          </Grid>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default CreditAppDoc;
